import React, {useEffect, useRef} from 'react';
import {sortAssetsLabels} from "../../../common/commonHandlers";
import MemoizedAssetSelectRow from "./MemoizedAssetSelectRow";
import PlantName from "../../../components/PlantName";
import {AutoSizer, List} from "react-virtualized";

const assetLabel = (a) => {
    return (
        <span className="overflow-checkbox-label">
                {a.label + ' - ' + (a.plant_count > 1 ? ' [' + a.plant_count + ']' : "")}
            <PlantName plant={a.plant_name}/>
            </span>
    )
}

const AssetsList = React.memo(({
                        searchString,
                        selectedId,
                        assets,
                        site,
                        assetClick,
                        checkPolygonsCoords,
                        setAssetChecked,
                        setState,
                        clearSelectedMarkerId
                    }) => {
    const listRef = useRef(null);
    const listAssets = [...assets].sort((a, b) => sortAssetsLabels(a, b, 'label'));
    const hasSelectedId = selectedId !== null && selectedId !== undefined;
    const selectedIndex = hasSelectedId ? listAssets.findIndex(l => l.id === selectedId) : -1;

    useEffect(() => {
        if (selectedIndex >= 0) {
            listRef.current?.scrollToRow(selectedIndex);
            clearSelectedMarkerId?.();
        }
    }, [selectedId]);

    const rowRenderer = ({index, key, style}) => {
        const asset = listAssets[index];

        return <MemoizedAssetSelectRow
            searchString={searchString}
            everyOther={index % 2 === 0}
            style={style}
            key={key}
            selected={asset.selected}
            checked={asset.checked}
            asset={asset}
            site={site}
            assetClick={assetClick}
            assetLabel={assetLabel}
            checkPolygonsCoords={checkPolygonsCoords}
            setAssetChecked={setAssetChecked}
            setState={setState}
        />
    }

    return <div className="assets top10" style={{height: "100%", minHeight: "300px"}}>
        <AutoSizer>
            {({width, height}) => (
                <List
                    ref={listRef}
                    height={height}
                    rowCount={listAssets.length}
                    scrollToAlignment={"start"}
                    rowHeight={50}
                    rowRenderer={rowRenderer}
                    width={width}
                />)}
        </AutoSizer>
    </div>
})

export default AssetsList;